import { render } from "./mensajeregalos_ingles.vue?vue&type=template&id=f584ed28&scoped=true"
import script from "./mensajeregalos_ingles.vue?vue&type=script&lang=js"
export * from "./mensajeregalos_ingles.vue?vue&type=script&lang=js"

import "./mensajeregalos_ingles.vue?vue&type=style&index=0&id=f584ed28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f584ed28"]])

export default __exports__